import i18n from '@/i18n/i18n'
import OrderDocumentService from '@/services/admin/OrderDocumentService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global
export const allowedSorts = 'created_at'
export const allowedAppends = 'document_verification_activity,mime_type'

export const namespaced = true

export const state = {
  document: null,
  previousDocuments: []
}

export const mutations = {
  SET_DOCUMENT(state, document) {
    state.document = document
  },
  SET_PREVIOUS_DOCUMENTS(state, previousDocuments) {
    state.previousDocuments = previousDocuments
  }
}

export const actions = {
  getDocument({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      OrderDocumentService.getDocument(params.orderId, params.documentId)
        .then(response => {
          commit('SET_DOCUMENT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewDocument({ dispatch, commit }, documentId) {
    return new Promise((resolve, reject) => {
      OrderDocumentService.viewDocument(documentId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  previousDocuments({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderDocumentService.previousDocuments(params.orderId, params.documentId)
        .then(response => {
          commit('SET_PREVIOUS_DOCUMENTS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateDocumentStatus({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      OrderDocumentService.updateDocumentStatus(params.orderId, params.documentId, params.data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.update_order_document_status_success')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  setDocument({ commit }, document) {
    commit('SET_DOCUMENT', document)
  }
}
